enum PermittedEntityType
{
    ExternalAgency = 0,
    Person = 1
}

export default PermittedEntityType;
